import { render, staticRenderFns } from "./save-documents-list.vue?vue&type=template&id=bd51b9c8&"
import script from "./save-documents-list.vue?vue&type=script&lang=js&"
export * from "./save-documents-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports